export const APP_EXTENSION_MODEL_TYPE = {
    PRODUCTS: 'PRODUCTS',
    PRODUCT_DESCRIPTION: 'PRODUCT_DESCRIPTION',
} as const
